import React from 'react';

const CommitmentSection = () => {
  return (
    <div
          className="commitment-section"
          style={{
            backgroundImage: 'url("/assets/images/transportation-illustration-ai-generated.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '400px',
            width: '100%',
          }}
        >
          <div style={{ height: '100%' }} className="d-flex justify-content-center align-items-center">
            <div className="commitment-content">
              <div className="text-content">
                <h4 className="text-uppercase Ethnocentric">Our Commitment</h4>
                <p style={{ lineHeight: '2' }}>
                  At Blue Dart, we don't just move shipments - we move promises. We're committed to delivering speed with care,
                  precision with every mile, and trust in every box. With certified processes, real-time tracking,
                  and a team that truly listens, we go the extra mile - so your business doesn't have to.
                </p>
              </div>
              <div className="image-content">
                <img src="/assets/images/transport-logistics-products.jpg" alt="Transport logistics" />
              </div>
            </div>
          </div>
        </div>
  );
};

export default CommitmentSection;
